import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import styles from './CharacterInfoButton.module.css';

interface CharacterInfoButtonProps {
  onClick: () => void;
  hasCharacterIssues: boolean;
}

const CharacterInfoButton: React.FC<CharacterInfoButtonProps> = ({
  onClick,
  hasCharacterIssues
}) => {
  return (
    <button
      onClick={onClick}
      className={styles.infoButton}
      style={{
        position: 'relative',
        top: '10px', // Relative offset from natural position
        left: '20px', // Relative offset from natural position
        zIndex: 1000, // Lower z-index since it's in document flow
        background: hasCharacterIssues 
          ? 'linear-gradient(135deg, #ea580c 0%, #dc2626 50%, #b91c1c 100%)'
          : '#6b7280',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        cursor: 'pointer',
        display: 'inline-flex', // Better for button in document flow
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.2s ease',
        marginBottom: '10px' // Space from content below
      }}
      title={hasCharacterIssues ? "Character issues detected - click to view" : "Character status info"}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1.0)';
      }}
    >
      <FontAwesomeIcon 
        icon={faInfoCircle} 
        style={{ fontSize: '16px' }}
      />
    </button>
  );
};

export default CharacterInfoButton;
